import { ListSortDirection, Sort } from "../../models/api/sort";
import { VendorInvoiceDTO, VendorInvoiceSTO } from "../../models/legal-entity-vendors/vendor-invoices";
import { BaseApiService } from "../base/base-api.service";

export class VendorInvoicesApiService extends BaseApiService<VendorInvoiceDTO, VendorInvoiceSTO> {
  constructor() {
    super({
      servicePath: "/VendorInvoices",
      loadItemsPath: "/GetVendorInvoices",
      saveItemsPath: "/SaveVendorInvoices",
    });
    this.defaultSort = [
      {
        name: "vendor.name",
        direction: ListSortDirection.Ascending,
      } as Sort,
    ];
  }
}
